import BaseObject from './BaseObject';
import {Matrix4, Mesh} from 'three';
import {MaterialTypes, ObjectTypes, ToothRootObjectDescription} from '@data/models';
import { GeometryProvider, MaterialsProvider } from '@data/providers';
import { WebGLScene } from '../WebGLScene';
import {Dictionary} from '@types';
import ToothObject from '@view/widgets/Scene/WebGLScene/objects/ToothObject';


class ToothRootObject extends BaseObject {
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.Tooth);
  }

  static async create(
    description: ToothRootObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(MaterialTypes.Tooth, undefined, description.jaw)
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    const obj = new ToothRootObject(mesh);
    obj.setInitial(position, rotation, scale);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }

  async update(description: ToothRootObjectDescription, objects: Dictionary<BaseObject>) {
    await super.update(description, objects);
    ToothObject.updateSemitransparency(this._mesh as Mesh, description.isSemitransparent);
  }
}

export default ToothRootObject;
